<template>
  <ReachIntInput
      ref="input"
      :formField="validatedField"
      :field-config="fieldConfig"
      :read-only="readOnly"
      :editor-mode="editorMode"
      :label="fieldConfig.fieldLabel"
      :hint="fieldConfig.shortHelpText"
      :help-title="fieldConfig.helpWindowTitle"
      :help-message="fieldConfig.htmlHelpText"
      :initialFocus="fieldConfig.autofocus"
      :min="fieldConfig.min"
      :max="fieldConfig.max"
      :placeholder="fieldConfig.formPlaceholder"
      :grid-editor="gridEditor"
      :open-from-grid="openFromGrid"
  >

  </ReachIntInput>
</template>

<script>

import ReachIntInput from "@/components/inputs/ReachIntInput";
import RtModule from "@/utils/RtModule";
import FormValidatedField from "@/components/forms/FormValidatedField";
import IntFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/IntFormFieldConfig";

export default {
  name: "IntegerRenderer",
  components: {ReachIntInput},
  mounted() {
    if (!RtModule().get(this.fieldConfig.toStringFunction)) {
      this.$refs.input.format = (val) => {
        return val !== null ? Intl.NumberFormat().format(val) : '';
      }
    } else {
      this.$refs.input.format = (val) => {
        return RtModule().get(this.fieldConfig.toStringFunction).call(this.validatedField, val,
            this.fieldConfig, this.validatedField.getFormConfig());
      }
    }
  },
  props: {
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: IntFormFieldConfig, required: true},
    openFromGrid: {default: false},
    gridEditor: {default: null},
  },

  methods: {
    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },
    setEditorMode(val){
      this.editorMode = val;
    },
  },

  data: () => ({
    readOnly: true,
    editorMode: false,
  })
}
</script>

<style scoped>

</style>